import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../lib/AuthContext";
import { formatApiError } from "../lib/api";
import { BrandMark } from "../components/LandingNav";

export default function ThankYou() {
  const { claimAccess } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const user = await claimAccess({ email, password, name });
      navigate(user.onboarded ? "/home" : "/onboarding", { replace: true });
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="relative min-h-screen flex items-center justify-center px-5 py-12">
      <div className="bps-ambient" />
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-lg"
        data-testid="thank-you-page"
      >
        <div className="text-center mb-8">
          <BrandMark className="justify-center mb-6" />
          <div className="w-16 h-16 rounded-2xl bg-[#10B981]/15 border border-[#10B981]/30 flex items-center justify-center mx-auto mb-5">
            <svg className="w-8 h-8 text-[#10B981]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </div>
          <div className="bps-eyebrow text-[#10B981]">Purchase Successful</div>
          <h1 className="font-display text-3xl sm:text-4xl font-bold text-white mt-3">
            Welcome to your transformation.
          </h1>
          <p className="text-[#B8C7DC] mt-4">
            Your payment is confirmed. Create your member login below to unlock instant access to your dashboard and Week 1.
          </p>
        </div>

        <form onSubmit={submit} className="bps-card p-6 sm:p-7 space-y-4" data-testid="claim-form">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#7C8FA8]">Your name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              data-testid="claim-name"
              className="bps-input mt-1"
              placeholder="Jane Doe"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#7C8FA8]">Email used at checkout</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              data-testid="claim-email"
              className="bps-input mt-1"
              placeholder="you@email.com"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#7C8FA8]">Create a password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              autoComplete="new-password"
              data-testid="claim-password"
              className="bps-input mt-1"
              placeholder="At least 6 characters"
            />
          </div>
          {err && <div className="text-sm text-[#F87171]" data-testid="claim-error">{err}</div>}
          <button
            disabled={loading}
            data-testid="claim-submit"
            className="w-full py-4 rounded-full bg-[#22D3EE] text-[#03101F] font-semibold disabled:opacity-30 transition-all hover:-translate-y-0.5"
          >
            {loading ? "Creating your access…" : "Unlock My Member Dashboard"}
          </button>
          <p className="text-center text-xs text-[#7C8FA8]">
            Already have an account?{" "}
            <button type="button" onClick={() => navigate("/login")} className="text-[#22D3EE]" data-testid="claim-goto-login">
              Log in
            </button>
          </p>
        </form>
      </motion.div>
    </div>
  );
}
